import { applyMiddleware, createStore, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import reducers from './reducer';

//  Returns the store instance
// It can  also take initialState argument when provided
const configureStore = () => {
  if (window.REACT_APP_LOG_ENABLED) {
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    // TODO: use configureStore method because createStore is deprecated
    return {
      ...createStore(
        reducers,
        composeEnhancers(applyMiddleware(thunk, logger))
      ),
    };
  } else {
    return {
      ...createStore(reducers, applyMiddleware(thunk)),
    };
  }
};

const store = configureStore();

export default store;
